import React, { Component } from 'react';
import { Card, Col, Container, Row } from "reactstrap";

import Notiflix from "notiflix";


import PostApiCall from '../../Api';
import logox from "../../assets/images/PAYMENT-SUCCESS.png";
import Header from '../../components/HorizontalLayout/Header';

class Chits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNo: '',
      ChitSchema: [],
      dropdownArray: [],
      searchInput: ''
    };
  }

  componentDidMount = () => {

    Notiflix.Loading.Init({
      svgColor: '#880105'

    });

    PostApiCall.postRequest(
      {
        id: localStorage.getItem("trxid"),
        paymentstatus: "Successfully Transfer",
      },
      "PaymentSuccess"
    ).then((result) =>
      result.json().then((obj) => {
        if (
          result.status === 200 ||
          result.status === 201
        ) {
          Notiflix.Loading.Remove();
          localStorage.removeItem("trxid");
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Loading.Failure(
            "Error processing data"
          );
        }
      }))

  }

  render() {

    return (
      <React.Fragment>
        <Header />

        <div className="page-content">
          <Container fluid>

            {/* Render Breadcrumb */}
            {/* <Breadcrumbs title={'Chits'} breadcrumbItem={'Chits List'} /> */}
            <Row>
              <Col xl="12">



                <Card className="overflow-hidden">
                  <Row>
                    <Col xl="12">
                      <img src={logox} className="form-control img-fluid mx-auto" style={{ height: '500px', objectFit: "contain" }}></img>
                    </Col>
                    <Col xl="12" className='my-4 text-center'>
                      <button className={'btn'} type="submit"
                        style={{
                          backgroundColor: '#880105', color: '#fff',
                        }}
                        onClick={() => {
                          window.location.href = 'http://admin.shanthijewellers.com/dashboard'
                        }}
                      > Go Back </button>
                    </Col>
                  </Row>

                </Card>


                {/* <WelcomeComp /> */}



              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
export default Chits